import * as React from 'react'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from '~/client/src/shared/components/shadcn-ui/select'

import type ViewMode from '../ViewSelector/ViewMode'

export interface IViewModeSelectProps {
  value: string
  modes: ViewMode[]
  onChange: (mode: string) => void
}

const ViewModeSelect: React.FC<IViewModeSelectProps> = ({
  value,
  modes,
  onChange,
}) => {
  const current = modes.find(mode => mode.mode === value) ?? modes[0]
  if (!current) return null

  const CurrentIcon = current.Icon

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger size="lg" aria-label={current.label ?? current.mode}>
        <CurrentIcon />
      </SelectTrigger>
      <SelectContent align="end">
        {modes.map(({ mode, Icon, label, isDisabled }) => (
          <SelectItem key={mode} value={mode} disabled={isDisabled} size="lg">
            <Icon />
            {label ?? mode}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}

export default ViewModeSelect
